// ─── src/components/sections/NewsletterBand.jsx ─────────────────────────────
import { useState } from "react";
import { useTheme } from "../../theme/ThemeContext";
import { track } from "../../utils/track";
import { subscribeNewsletter } from "../../services/newsletterService";

const GD = "var(--font-heading-primary)";
const NU = "var(--font-body)";

export default function NewsletterBand() {
  const C = useTheme();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async () => {
    if (!email.trim()) return;
    setLoading(true);
    setError("");
    track("newsletter_submit", { email });
    const result = await subscribeNewsletter({ email, source: "homepage_band" });
    setLoading(false);
    if (result.ok) {
      setDone(true);
    } else {
      setError(result.error || "Something went wrong. Please try again.");
    }
  };

  return (
    <section
      aria-label="Newsletter signup"
      className="home-newsletter"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 0,
        background: "#0a0806",
        padding: "100px 40px",
        textAlign: "center",
        overflow: "hidden",
      }}
    >
      {/* Background image */}
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "url('https://images.unsplash.com/photo-1602088113235-229c19758e9f?auto=format&fit=crop&w=1920&q=60')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "blur(1px)",
        }}
      />
      {/* Dark overlay */}
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(10,8,6,0.82) 0%, rgba(10,8,6,0.72) 50%, rgba(10,8,6,0.82) 100%)",
        }}
      />
      {/* Gold radial glow */}
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(ellipse 50% 50% at 50% 50%, rgba(211,154,33,0.06) 0%, transparent 70%)",
        }}
      />

      <div style={{ position: "relative", maxWidth: 580, margin: "0 auto" }}>
        {/* Label */}
        <div
          style={{
            fontFamily: NU,
            fontSize: 10,
            letterSpacing: "3px",
            textTransform: "uppercase",
            color: "#d39a21",
            marginBottom: 16,
            fontWeight: 600,
          }}
        >
          Join 52,000+ Couples
        </div>

        {/* Headline */}
        <h2
          className="home-newsletter-headline"
          style={{
            fontFamily: GD,
            fontSize: "clamp(28px, 4vw, 52px)",
            color: "#f5f0e8",
            fontWeight: 400,
            lineHeight: 1.1,
            marginBottom: 12,
          }}
        >
          Join the World of{" "}
          <span style={{ display: "block", fontStyle: "italic", color: "#d39a21" }}>
            Luxury Weddings
          </span>
        </h2>

        {/* Subline */}
        <p
          style={{
            color: "#999",
            fontSize: 15,
            fontFamily: NU,
            fontWeight: 300,
            lineHeight: 1.7,
            marginBottom: 36,
          }}
        >
          Weekly vendor spotlights, real wedding stories, and curated
          inspiration, trusted by 52,000+ couples planning across
          Europe and beyond.
        </p>

        {/* Email input */}
        <style>{`
          .lwd-nl-form{display:flex;max-width:440px;margin:0 auto;}
          .lwd-nl-input{flex:1;background:#1a1a1a;border:1px solid #3a3a3a;border-right:none;border-radius:4px 0 0 4px;color:#f5f0e8;padding:15px 18px;font-size:14px;outline:none;font-family:inherit;}
          .lwd-nl-btn{background:#d39a21;border:none;border-radius:0 3px 3px 0;color:#111;padding:15px 28px;font-size:11px;font-weight:800;letter-spacing:2px;text-transform:uppercase;cursor:pointer;white-space:nowrap;transition:background 0.2s;font-family:inherit;}
          .lwd-nl-btn:hover{background:#d4b85c;}
          @media(max-width:540px){
            .lwd-nl-form{flex-direction:column;}
            .lwd-nl-input{border-right:1px solid #3a3a3a;border-bottom:none;border-radius:4px 4px 0 0;}
            .lwd-nl-btn{border-radius:0 0 4px 4px;padding:14px;}
          }
        `}</style>
        {done ? (
          <div style={{ color: "#d39a21", fontFamily: GD, fontSize: 20, fontStyle: "italic" }}>
            ✦ Welcome to the community, we'll be in touch!
          </div>
        ) : (
          <>
            <div className="lwd-nl-form home-newsletter-form">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && submit()}
                placeholder="your@email.com"
                aria-label="Email address"
                className="lwd-nl-input"
                disabled={loading}
              />
              <button onClick={submit} className="lwd-nl-btn" disabled={loading}>
                {loading ? "…" : "Subscribe"}
              </button>
            </div>
            {error && (
              <p style={{ color: "#e07070", fontFamily: NU, fontSize: 12, marginTop: 10 }}>
                {error}
              </p>
            )}
          </>
        )}
      </div>
    </section>
  );
}
